import { useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useGetBusinessPlanPDFBinaryData = (id: string) =>
  useQuery({
    queryKey: businessPlanQueryKeys.getBusinessPlanPDFBinary(id),
    queryFn: () => BusinessPlanApi.getBusinessPlanPDFBinary(id),
  });
